(() => {
  const apiName = 'InfrarediTrackingFaq';
  const rootSelector = '[data-ir-tracking-faq-root]';

  function setExpanded(item, expanded, animate) {
    const trigger = item.querySelector('[data-ir-tracking-faq-trigger]');
    const content = item.querySelector('[data-ir-tracking-faq-content]');
    if (!trigger || !content) return;

    const state = expanded ? 'open' : 'closed';
    if (expanded) content.hidden = false;

    content.style.setProperty(
      '--ir-tracking-faq-content-height',
      `${content.scrollHeight}px`
    );
    trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    item.dataset.state = state;
    content.dataset.state = state;

    if (!animate) {
      content.hidden = !expanded;
      content.style.removeProperty('--ir-tracking-faq-content-height');
    }
  }

  function init(root) {
    if (!root || root.dataset.irTrackingFaqReady === 'true') return;
    root.dataset.irTrackingFaqReady = 'true';

    root.querySelectorAll('[data-ir-tracking-faq-item]').forEach((item) => {
      const trigger = item.querySelector('[data-ir-tracking-faq-trigger]');
      const content = item.querySelector('[data-ir-tracking-faq-content]');
      if (!trigger || !content) return;

      setExpanded(item, trigger.getAttribute('aria-expanded') === 'true', false);

      trigger.addEventListener('click', () => {
        setExpanded(item, trigger.getAttribute('aria-expanded') !== 'true', true);
      });

      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        trigger.click();
      });

      content.addEventListener('animationend', (event) => {
        if (event.target !== content) return;
        if (content.dataset.state === 'closed') content.hidden = true;
        content.style.removeProperty('--ir-tracking-faq-content-height');
      });
    });
  }

  function initAll(scope = document) {
    if (scope.matches && scope.matches(rootSelector)) init(scope);
    scope.querySelectorAll(rootSelector).forEach(init);
  }

  if (window[apiName]) {
    window[apiName].initAll();
    return;
  }

  window[apiName] = { initAll };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
